import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductOptionPicker } from './ProductOptionPicker';
import { Shopify } from '@eastsideco/salvo-ts/lib/generated/shopify-types';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

@Component
export class ProductGallery extends ThemeComponent {
    @Ref({ required: false }) first!: HTMLDivElement[];
    private imageHold: Shopify.Liquid.Image | null = null;

    init() {
        const productOptionPicker = document.querySelector('#product-form-option-picker');

        if (productOptionPicker && productOptionPicker.tagName === 'PRODUCT-OPTION-PICKER') {
            const productOptionPickerComponent = productOptionPicker as ProductOptionPicker;

            // eslint-disable-next-line max-len
            this.$subscribe(productOptionPickerComponent.onSelectedVariantChange, (variant: Shopify.Liquid.Variant | null) => {
                let image = null;
                if (variant?.featured_image) {
                    image = variant?.featured_image;
                }
                this.imageHold = image;
                this.handleOnVariantchange(variant, image);
            });
        }

        // Setup gallery image zoom/lightbox
        this.setupLightbox();

    }
    handleOnVariantchange(variant: Shopify.Liquid.Variant | null, image: Shopify.Liquid.Image | null) {
        if (!image || !this.first?.length) {return;}

        for (const element of this.first) {
            const img = element.querySelector('img');
            if (!img) {return;}

            const parent = img.closest('.product-gallery__media__image');
            if (parent) {
                parent.setAttribute('href', image.src);
            }
            img.setAttribute('src', image.src);
            img.setAttribute('height', image.height.toString());
            img.setAttribute('width', image.width.toString());
            img.setAttribute('alt', image.alt || 'Product gallery Image');
        }
    }
    setHoldImage() {
        if (!this.imageHold || !this.first?.length) {return;}

        for (const element of this.first) {
            const img = element.querySelector('img');
            if (!img) {return;}

            if (this.imageHold) {
                const parent = img.closest('.product-gallery__media__image');
                if (parent) {
                    parent.setAttribute('href', this.imageHold.src);
                }
                img.setAttribute('src', this.imageHold.src);
                img.setAttribute('height', this.imageHold.height.toString());
                img.setAttribute('width', this.imageHold.width.toString());
                img.setAttribute('alt', this.imageHold.alt || 'Product gallery Image');
            }
        }
    }


    setupLightbox() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: '.product-gallery__main',
            children: '.product-gallery__media-item',
            initialZoomLevel: 0,
            pswpModule: PhotoSwipe
        });

        lightbox.init();

    }

}
